import { CACHE_CONFIG } from "./config";

interface CacheEntry<T = unknown> {
    data: T;
    timestamp: number;
}

class PriceHistoryCache {
    private cache: Map<string, CacheEntry>;
    private readonly duration: number;

    constructor(duration: number = CACHE_CONFIG.PRICE_HISTORY_TTL) {
        this.cache = new Map();
        this.duration = duration;
    }

    get(key: string): unknown | null {
        const entry = this.cache.get(key);
        if (!entry) return null;

        const now = Date.now();
        if (now - entry.timestamp > this.duration) {
            this.cache.delete(key);
            return null;
        }

        return entry.data;
    }

    set(key: string, data: unknown): void {
        this.cache.set(key, {
            data,
            timestamp: Date.now()
        });
    }

    clear(): void {
        this.cache.clear();
    }

    // Clean up expired entries
    cleanup(): void {
        const now = Date.now();
        for (const [key, entry] of this.cache.entries()) {
            if (now - entry.timestamp > this.duration) {
                this.cache.delete(key);
            }
        }
    }
}

// Create a singleton instance
let priceHistoryCache: PriceHistoryCache | null = null;

export const getPriceHistoryCache = (): PriceHistoryCache => {
    if (!priceHistoryCache) {
        priceHistoryCache = new PriceHistoryCache();
    }
    return priceHistoryCache;
}; 